import React from "react";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";

import Card from "../common/card";

import INFO from "../../data/user";

import "./styles/works.css";

const WORKS = INFO.works.map((work, index) => (
	<div className="work" key={index}>
		<img src={work.logo} alt={work.alt} className="work-image" />
		<div className="work-title">{work.workTitle}</div>
		<div className="work-subtitle">{work.workSubtitle}</div>
		<div className="work-duration">{work.workDuration}</div>
	</div>
));

const Works = () => {
	return (
		<div className="works">
			<Card
				icon={faBriefcase}
				title="Studies and Experience"
				body={WORKS}
			/>
		</div>
	);
};

export default Works;
